import React from "react";
import PropTypes from "prop-types";
import { Wrapper } from "@googlemaps/react-wrapper";

import {getDownloadCounter, getGoogleGeoData} from "../../utils/journals";


// Wrap map component with required credentials
export const JournalGoogleMap = (props) => {
  return (
    <Wrapper apiKey="AIzaSyDWS-onnS70PqLoECLU6l-BfUAcQQFkek0">
      <JournalMap {...props} />
    </Wrapper>
  )
}


class JournalMap extends React.Component {

  /** HTMLDivElement **/
  // mapRef;
  // map;
  /** Number[] **/
  // timeoutIds = [];
  //mounted = false;


  constructor(props) {
    super(props);
    this.mapRef = React.createRef();
    this.map = null;
    this.timeoutIds = [];
    this.mounted = false;
    this.state = {
      counterValue: null,
      userDownloadValue: null
    }
  }

  componentDidMount() {
    if (this.mapRef.current && !this.map) {
      this._loadMap();
      this._loadDataIntoMap();
      this._loadDataIntoCounter();
    }
    this.mounted = true;
  }

  componentWillUnmount() {
    for(let i = 0; i < this.timeoutIds.length; i++) {
      clearTimeout(this.timeoutIds[i]);
    }
    this.timeoutIds = [];
  }

  _loadMap() {
    this.map = new window.google.maps.Map(this.mapRef.current, {
      zoom: 3,
      center: new window.google.maps.LatLng(-25.274398, 133.775136),
      mapId: "d7b42814bf968e06",
      disableDefaultUI: true,
      useStaticMap: true,
    });
  }

  _loadDataIntoMap() {
    getGoogleGeoData(this.props.journalName, (responseString) => {
      let jsonResponse = JSON.parse(responseString);
      this._eqfeed_callback(jsonResponse);
    });
  }

  _loadDataIntoCounter() {
    getDownloadCounter(this.props.journalName, (counter) => {
      let counterSuffix = "time";
      if (counter !== 1) {
        counterSuffix = counterSuffix + "s";
      }
      // console.log(counterElement.textContent)
      this.setState({counterValue: counter + " " + counterSuffix})
    });
  }

  // Loop through the results array and place a marker for each set of coordinates.
  _eqfeed_callback(results) {

    // filter out "bad" results
    const filteredResults = results.features.filter((feature, i) => feature.geometry?.coordinates && feature.geometry?.city)

    // instead of setting up ~200 timeouts all at once, use recursive function that sets single timeout each time
    // const self = this;
    // function delayedPinDrop(i){
    //   const coords = filteredResults[i].geometry.coordinates;
    //   const latLng = new window.google.maps.LatLng(coords[1], coords[0]);
    //   self.setState({userDownloadValue: filteredResults[i].geometry.city})
    //   // userDownloadDiv.innerText = results.features[i].geometry.city;
    //   new window.google.maps.Marker({
    //     position: latLng,
    //     map: self.map,
    //     animation: window.google.maps.Animation.DROP,
    //     icon: {
    //       path: window.google.maps.SymbolPath.CIRCLE,
    //       scale: 3,
    //     },
    //   });
    //
    //   if (i+1 < filteredResults.length) {
    //     setTimeout(() => delayedPinDrop(i+1),2000)
    //   }
    // }
    //
    // delayedPinDrop(0);


    // show locations as text
    // It's ok to set 200+ timers at once, they have a very small performance footprint
    for (let i = 0; i < filteredResults.length; i++) {
      const coords = filteredResults[i].geometry.coordinates;
      const latLng = new window.google.maps.LatLng(coords[1], coords[0]);
      // TODO check use of set state in timeout function
      this.timeoutIds.push(setTimeout(() => {
        if (!this.mounted) return;

        this.setState({userDownloadValue: filteredResults[i].geometry.city})
        // userDownloadDiv.innerText = results.features[i].geometry.city;
        new window.google.maps.Marker({
          position: latLng,
          map: this.map,
          animation: window.google.maps.Animation.DROP,
          icon: {
            path: window.google.maps.SymbolPath.CIRCLE,
            scale: 3,
          },
        });
      }, i * 2000));
    }
  }

  render() {
    return (
      <div className="map-wrapper">
        <p>
          <strong>Reader from <span id="download-userLocation">{this.state.userDownloadValue}</span></strong>
        </p>
        <div id="download-map" ref={this.mapRef} style={{position: "relative", overflow: "hidden", height: "500px", width: "100%"}} />
        <br />
        <p>
          {this.props.journalName} has been downloaded <span id="download-counter">{this.state.counterValue}</span>
        </p>
      </div>
    )
  }

}

JournalGoogleMap.propTypes = JournalMap.propTypes = {
  journalName: PropTypes.string
}
